import {useTranslation} from "react-i18next";
import {Table} from "react-bootstrap";
import DateDisplay from "components/datetime/DateDisplay";

import IconBool from "components/IconBool";
import useCustomTranslation from "core/customTranslation";
import Queue from "components/queues/Queue";
import translations from "./translations";
import OrderByHeaders from "components/ordering/OrderByHeaders";

const TableConfig = ({items, itemsShow, buttonsTB, setButtonsTB, checkAll, setCheckAll, orderingRef}) => {
    const {t: _Tch} = useTranslation("choices");
    const {t: _Tc} = useCustomTranslation(translations);

    const onClick = (e) => {
        let checkbox;
        if (e.target.type === "checkbox") {
            checkbox = e.target;
        } else {
            checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;
        }

        if (checkbox.checked) {
            items.current.addToChosen(e.currentTarget.dataset.idx);
        } else {
            items.current.removeFromChosen(e.currentTarget.dataset.idx);
        }
        items.current.updatePrev();
        handleButtons();
    };

    const handleCheckAll = (e) => {
        let checkboxList = document.querySelectorAll('input[type="checkbox"]');
        if (e.target.checked) {
            setCheckAll(true);
            items.current.chosen = itemsShow.map((item) => item.uuid);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = true;
            });
            handleButtons();
        } else {
            setCheckAll(false);
            checkboxList.forEach((checkbox) => {
                checkbox.checked = false;
            });
            items.current.clearChosen();
            handleButtons();
        }
    };

    const handleButtons = () => {
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length === 0;
        buttons.send.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    const get_senders = (it) => {
        let words = [];
        it.carry_ship && words.push(_Tc("send.type.measurement"));
        it.carry_sensors && words.push(_Tc("send.type.sensors"));
        it.carry_alerts && words.push(_Tc("send.type.alerts"));

        return words.join(", ");
    };

    return (
        <Table striped hover responsive>
            <thead>
                <tr>
                    <th key="-1" style={{width: "32px", verticalAlign: "bottom"}}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            value="all"
                            checked={checkAll}
                            onChange={handleCheckAll}
                        />
                    </th>
                    <OrderByHeaders orderingRef={orderingRef} />
                    <th>
                        {_Tc("table.header.config")}
                        <br />
                        {_Tc("table.header.actual")}
                    </th>
                    <th>
                        {_Tc("table.header.mode")}
                        <br />
                        <span className="small">{_Tc("table.header.confirmations")}</span>
                        <br />
                        <span className="small">{_Tc("table.header.date")}</span>
                        <br />
                    </th>
                    <th>
                        {_Tc("table.header.power")}
                        <br />
                        <span className="small">{_Tc("table.header.confirmations")}</span>
                        <br />
                        <span className="small">{_Tc("table.header.date")}</span>
                        <br />
                    </th>
                    <th>
                        {_Tc("table.header.alert")}
                        <br />
                        <span className="small">{_Tc("table.header.confirmations")}</span>
                        <br />
                        <span className="small">{_Tc("table.header.date")}</span>
                        <br />
                    </th>
                    <th>{_Tc("table.header.updated")}</th>
                    <th>{_Tc("table.header.status")}</th>
                    <th>{_Tc("table.header.queue")}</th>
                </tr>
            </thead>

            <tbody id="data-list">
                {itemsShow.length ? (
                    itemsShow.map((item) => (
                        <tr key={item.uuid} data-idx={item.uuid} onChange={onClick}>
                            <td>
                                <input
                                    type="checkbox"
                                    name="checkboxOpModes"
                                    key={item.uuid}
                                    data-idx={item.uuid}
                                    defaultChecked={items.current.chosen.includes(item.uuid)}
                                    readOnly={true}
                                />
                            </td>
                            <td>
                                {item.uuid}
                                <br />
                                {item.model}
                            </td>
                            <td>
                                {item.config_name} <br />
                                {get_senders(item)}
                            </td>
                            <td>
                                {item.ships_name}
                                <br />
                                <span title={_Tc("confirm.sent")} className="me-2">
                                    {_Tc("confirm.sent.short")} {<IconBool value={item.ship_send} />}
                                </span>
                                <span title={_Tc("confirm.confirmed")}>
                                    {_Tc("confirm.confirmed.short")} {<IconBool value={item.ship_ack} />}
                                </span>
                                <br />
                                <DateDisplay date={item.ship_cc_at} format="DD-MM-YYYY hh:mm" title={true} />
                            </td>
                            <td>
                                {item.sensors_name}
                                <br />
                                <span title={_Tc("confirm.sent")} className="me-2">
                                    {_Tc("confirm.sent.short")} {<IconBool value={item.sensors_send} />}
                                </span>
                                <span title={_Tc("confirm.confirmed")}>
                                    {_Tc("confirm.confirmed.short")} {<IconBool value={item.sensors_ack} />}
                                </span>
                                <br />
                                <DateDisplay date={item.sensors_cc_at} format="DD-MM-YYYY hh:mm" title={true} />
                            </td>
                            <td>
                                {item.alerts_name}
                                <br />
                                <span title={_Tc("confirm.sent")} className="me-2">
                                    {_Tc("confirm.sent.short")} {<IconBool value={item.alerts_send} />}
                                </span>
                                <span title={_Tc("confirm.confirmed")}>
                                    {_Tc("confirm.confirmed.short")} {<IconBool value={item.alerts_ack} />}
                                </span>
                                <br />
                                <DateDisplay date={item.alerts_cc_at} format="DD-MM-YYYY hh:mm" title={true} />
                            </td>
                            <td>
                                <DateDisplay date={item.updated_at} format="DD-MM-YYYY hh:mm" title={true} />
                            </td>
                            <td>{_Tch("shippingState." + item.state)}</td>
                            <td>
                                <Queue item={item.queue} />
                            </td>
                        </tr>
                    ))
                ) : (
                    <></>
                )}
            </tbody>
        </Table>
    );
};

export default TableConfig;
